import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';
import { Marquee } from '@components/main-components/marquee/Marquee';

export const heroTitleStyles: CSS = {
  title: 'XL',
  '@tablet': {
    title: 'XXL',
  },
  color: '$white',
};

export const HeroTitle = ({ title }: { title: string }) => (
  <Title>
    <Marquee>
      <h3>{title}</h3>
    </Marquee>
  </Title>
);

const Title = styled('div', {
  ...heroTitleStyles,
  maxWidth: '100%',
});

export const HeroDetailsMobile = styled('div', {
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  paddingBottom: 4,
  '@tablet': {
    display: 'none',
    paddingBottom: 0,
  },
});

export const HeroInfoWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  minWidth: 0,
});

export const HeroPlayInfoWrapper = styled('div', {
  display: 'flex',
  gap: 16,
  width: '100%',
  alignItems: 'center',
  height: 82,
});
